import gql from 'graphql-tag';

export default gql`
  {
    getOffices {
      id
      img_visual_desktop
      img_visual_mobile
      img_logo_desktop
      img_logo_mobile
      detail {
        title
        slug
        content
        cta_label
        cta_url
        language_code
      }
      socialNetworks {
        id
        name
        url
      }
    }
  }
`;
